import {
  Modal,
  Box,
  Typography,
  IconButton,
  Stack,
  Chip,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Tag as TagIcon, Group as GroupIcon } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  maxHeight: "80vh",
  overflowY: "auto",
};

export const FeedbackDetailModal = ({ open, onClose, card }) => {
  return (
    card && (
      <Modal open={open} onClose={onClose}>
        <Box sx={style}>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              mb: 1,
              gap: 2,
              paddingTop: "10px",
            }}
          >
            <Box>
              <Typography
                variant="caption"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  color: "#666",
                  display: "block",
                  mb: 0.5,
                }}
              >
                Enviado por: {card.usuarioCriadorNome || "Anônimo"}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  color: "#666",
                  display: "block",
                  mb: 0.5,
                }}
              >
                Enviado para: {card.usuarioReceptorNome || "Todos do setor"}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Montserrat, sans-serif",
                  color: "#014F6D",
                  mb: 0.5,
                }}
              >
                {card.assunto}
              </Typography>

              <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                <Chip
                  icon={<TagIcon color="#2196F3" />}
                  label={card.feedbackTipoNome}
                  size="small"
                  variant="outlined"
                  sx={{
                    color: "#2196F3",
                    border: "1px solid #2196F3",
                    padding: "5px",
                  }}
                />
                <Chip
                  icon={<GroupIcon color="#FF6B35" />}
                  label={card.feedbackSetorNome}
                  size="small"
                  sx={{
                    color: "#FF6B35",
                    border: "1px solid #FF6B35",
                    padding: "5px",
                  }}
                  variant="outlined"
                />
              </Stack>
            </Box>

            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                fontFamily: "Montserrat, sans-serif",
                whiteSpace: "nowrap",
              }}
            >
              {new Date(card.criado_em).toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </Typography>
          </Box>

          <Divider sx={{ my: 1 }} />

          <Typography
            variant="body1"
            sx={{
              whiteSpace: "pre-line",
              wordBreak: "break-word",
              color: "#333",
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            {card.texto}
          </Typography>
        </Box>
      </Modal>
    )
  );
};
